<template>
  <div class="restaurant-list" :class="classes" v-if="block?.data?.restaurants?.length">
    <div v-if="block.data?.title || block.data?.excerpt">
      <AtomBlockHeader
        :heading="block.data?.title"
        :leading="block.data?.excerpt"
      />
    </div>
    <div class="restaurant-list__grid">
      <div class="restaurant-list__item" v-for="restaurant, key in block?.data?.restaurants" :key="restaurant?.id">
        <NuxtLink :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}">
          <BlocksRestaurantListCompactCard :position="key+1" :restaurant="restaurant" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
.restaurant-list {
  @apply @container;
  @apply my-4 grid gap-4;

  &__grid {
    @apply grid gap-4;
    @apply @xl:gap-6 @xl:grid-cols-2;
    @apply @4xl:grid-cols-3;
  }

  &__item {
    // 
  }
}
</style>